import * as selectCourse from '../actions/selectCourse';

const defaultState = {
    courses: []
};

export default function(state = defaultState, { type, courses }) {

    switch (type) {

        case selectCourse.SELECT_COURSE_LIST_REFRESHED:

            return {
                ...state,
                courses
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/selectCourseList.js